module.exports = __webpack_public_path__ + "img/ARTE_EIXONOS.d2a6ef65.png";